const claim = [{
  desc: '理赔列表查询',
  options: {
    url: '/claim/queryList',
    method: 'post'
  }
}, {
  desc: '编辑理赔信息',
  options: {
    url: '/claim/saveClaim',
    method: 'post'
  }
}, {
  desc: '理赔报表查询',
  options: {
    url: '/claim/queryReportList',
    method: 'post'
  }
}, {
  desc: '理赔报表导出',
  options: {
    url: '/claim/exportReport',
    method: 'post',
    responseType: 'arraybuffer'
  }
}]
export default claim



// WEBPACK FOOTER //
// ./src/api/claim.js